import React, { useEffect, useRef } from "react";
import { createContext } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import API from "../common/Api";

const mapStateToProps = (state) => ({
  headers: { headers: state.headers() },
  business: state.business,
});

const StatsContext = createContext();

export default connect(mapStateToProps)(function StatsProvider({
  children,
  ...props
}) {
  const [stats, setStats] = useState(null);
  const [sortedBookings_byDate, setSortedBookings_byDate] = useState(null);
  const [upcoming_bookings, setUpcoming_bookings] = useState(null);
  const [past_bookings, setPast_bookings] = useState(null);


 const prevTokenRef = useRef(null);
 const prevBusinessIdRef = useRef(null);

 const fetchAppointments = () => {
   if (props.headers?.headers?.Authorization) {
     API.get("business/appointments", props.headers).then(
       ({
         data: {
           data: {
             bookings: { upcoming_appointments, past_appointments },
           },
         },
       }) => {
         setUpcoming_bookings(upcoming_appointments);
         setPast_bookings(past_appointments);
       }
     );
   }
 };

 useEffect(() => {
   const authToken = props.headers?.headers?.Authorization;
   const prevToken = prevTokenRef.current;

   const businessId = props.business?.id;
   const prevBusinessId = prevBusinessIdRef.current;

   const tokenHasChanged = prevToken !== authToken && !!authToken;
   const businessHasLoaded = prevBusinessId !== businessId && !!businessId;

   if (tokenHasChanged || businessHasLoaded) {
     API.get("business/stats", props.headers).then(
       ({ data: { data: stats } }) => {
         setStats(stats);
       }
     );

     fetchAppointments();
   }

   prevTokenRef.current = authToken;
   prevBusinessIdRef.current = businessId;
 }, [props.headers?.headers?.Authorization, props.business?.id]);


  useEffect(() => {
    const bookings = stats?.bookings;
    if (bookings) setSortedBookings_byDate({ ...bookings });
  }, [stats]);

  return (
    <StatsContext.Provider
      value={{
        stats,
        sortedBookings_byDate,
        upcoming_bookings,
        past_bookings,
        fetchAppointments,
      }}
    >
      {children}
    </StatsContext.Provider>
  );
});

export { StatsContext };
